import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

const b64ToU8 = (s) => {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export default function PushToggle() {
  const supported = typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  const [sub, setSub] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!supported) return;
    navigator.serviceWorker.register("/sw.js").then((reg) => reg.pushManager.getSubscription()).then(setSub).catch(() => {});
  }, [supported]);

  const enable = async () => {
    setBusy(true);
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") { toast.error("Permesso notifiche negato"); return; }
      const reg = await navigator.serviceWorker.ready;
      const { data } = await api.get("/push/public-key");
      const s = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.public_key) });
      await api.post("/push/subscribe", s.toJSON());
      setSub(s);
      await api.post("/push/test");
      toast.success("Notifiche attivate");
    } catch (e) { toast.error("Impossibile attivare le notifiche"); }
    finally { setBusy(false); }
  };

  const disable = async () => {
    setBusy(true);
    try {
      await api.delete("/push/subscribe", { data: sub.toJSON() });
      await sub.unsubscribe(); setSub(null); toast.success("Notifiche disattivate");
    } catch { toast.error("Errore"); }
    finally { setBusy(false); }
  };

  if (!supported) {
    return <span className="p-2 text-stone-300" title="Aggiungi l'app alla schermata Home per le notifiche" data-testid="push-unsupported"><BellOff className="w-5 h-5" /></span>;
  }
  return (
    <button onClick={sub ? disable : enable} disabled={busy} className={`p-2 ${sub ? "text-[#15803D]" : "text-stone-500"}`}
      data-testid="push-toggle-btn" title={sub ? "Notifiche attive (tocca per disattivare)" : "Attiva notifiche"}>
      {sub ? <BellRing className="w-5 h-5" /> : <Bell className="w-5 h-5" />}
    </button>
  );
}
